import { bl_fi_entity_purchase_credit_terms_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class EntityPurchseCreditTermsImportFileHelperContainerModel extends BaseContainerModel {
    bl_fi_entity_purchase_credit_terms_import_file_helper: bl_fi_entity_purchase_credit_terms_import_file_helper_RowClass = new bl_fi_entity_purchase_credit_terms_import_file_helper_RowClass();
}